import { brighten, getValue } from "../utils.js";

export const RATING = {
  "Rating.Selected.Bg.Color": {
    ref: "Color.Secondary.Three.500"
  },
  "Rating.Icon.Gap": {
    ref: "Space.8"
  },
  "Rating.Disabled.Unselected.Bg.Color": {
    ref: "Gray.200"
  },
  "Rating.Disabled.Selected.Bg.Color": {
    valueFunc: (meta) => {
      return brighten(getValue("Rating.Selected.Bg.Color", meta), 0.5);
    }
  },
  "Rating.Border.Color": {
    ref: "Input.Border.Color"
  },
  "Rating.Icon.Size": {
    defaultValue: "20px"
  }
};
